let skipHandler: (() => void) | null = null

export function registerSkipNextPageLeaveConfirm(handler: () => void): void {
  skipHandler = handler
}

export function unregisterSkipNextPageLeaveConfirm(): void {
  skipHandler = null
}

export function skipNextPageLeaveConfirm(): void {
  skipHandler?.()
}

export function resetPageLeaveGuardBridgeForTests(): void {
  skipHandler = null
}
